module.exports = __webpack_public_path__ + "img/apongt-image-box.9b691d37.jpg";